import { LyOverlayContainer } from './overlay-container.component';
import { NgModule, SkipSelf, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomService } from './dom.service';
export function LY_OVERLAY_CONTAINER_PROVIDER_FACTORY(parentContainer) {
    return parentContainer || new LyOverlayContainer();
}
export var LY_OVERLAY_CONTAINER_PROVIDER = {
    // If there is already an OverlayContainer available, use that. Otherwise, provide a new one.
    provide: LyOverlayContainer,
    deps: [[new Optional(), new SkipSelf(), LyOverlayContainer]],
    useFactory: LY_OVERLAY_CONTAINER_PROVIDER_FACTORY
};
var LxDomModule = /** @class */ (function () {
    function LxDomModule() {
    }
    LxDomModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    providers: [[DomService, LY_OVERLAY_CONTAINER_PROVIDER]]
                },] },
    ];
    /** @nocollapse */
    LxDomModule.ctorParameters = function () { return []; };
    return LxDomModule;
}());
export { LxDomModule };
//# sourceMappingURL=lx-dom.module.js.map